import { paneModes } from '@constants/orderWizard'
import { useWizardMaster } from '../Contexts/WizardMasterContext'
import { TypeSelect } from './ControlPane/TypeSelect'
import { TankImpact } from './ControlPane/TankImpact'
import { SupplyFilters } from './ControlPane/PaneComponents/SupplyFilters'
import { ProductSelect } from './ControlPane/ProductSelect'

export const ControlPane = ({ cancelOrder, resetOrder }) => {
  const { paneMode } = useWizardMaster()
  const backgroundOverride = paneMode === paneModes.TYPESELECT ? 'colored-bg' : ''

  return (
    <div className={`control-pane ${backgroundOverride}`}>
      <PaneSwitch paneMode={paneMode} cancelOrder={cancelOrder} resetOrder={resetOrder} />
    </div>
  )
}

const PaneSwitch = ({ paneMode, cancelOrder, resetOrder }) => {
  switch (paneMode) {
    case paneModes.TANKIMPACT:
      return <TankImpact cancelOrder={cancelOrder} resetOrder={resetOrder} />
    case paneModes.TYPESELECT:
      return <TypeSelect />
    case paneModes.PRODUCTSELECT:
      return <ProductSelect />
    case paneModes.SUPPLYFILTERS:
      return <SupplyFilters />
    default:
      return <>Invalid Pane Mode</>
  }
}
